import http from "@/utils/request"

export default {
  save: function (inputForm) {
    return http.post(
      '/erp/common/erpFormHeader/save',
      inputForm
    )
  },
  queryById: function (id) {
    return http.get(
      '/erp/common/erpFormHeader/list',
      id
    )
  },
}
